import React, { Component } from 'react'
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from 'react-bootstrap-table';
import {customStandardActions} from '../../../Utils/Grid/StandardActions';
import CardSimple from '../../../Utils/Cards/cardSimple';
import renderFieldCheck from '../../../Utils/renderField'
import {estado_bodega} from '../../../../../utility/icons';
import { Link } from 'react-router-dom';


export default class CajasChicasGrid extends Component {

    componentWillMount() {
        const { match, listar, page } = this.props;
        const id = match.params.id;
        listar(page, id);
    }

    onPageChange = newPage => {
        const { match, listar } = this.props;
        const id = match.params.id;
        listar(newPage, id);
      };

    isCheckDisabled = row => {
        if (row.id_usuario == this.props.match.params.id) return true
        else return false
    }

    render() {
        const { data, loader, listar: onPageChange, onSortChange, page, guardar } = this.props;

        return (
            <CardSimple
                titulo="Cajas Chicas">
                    <Grid
                        hover
                        striped
                        data={data}
                        loading={loader}
                        onPageChange={this.onPageChange}
                        onSortChange={onSortChange}
                        pagination={false}
                        page={page}>
                        <TableHeaderColumn
                            isKey
                            dataField="nombre"
                            dataSort
                            dataFormat={
                                (cell,row)=> cell ? (`${cell}`):"-------"
                            }
                        >
                            NOMBRE
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width="7%"
                            dataFormat={(cell, row) => {
                                return customStandardActions(cell, {
                                    adicional: (c, r) => {
                                        return <label className={`mb-0 d-flex py-1 px-0 px-sm-1 flex-row algin-items-center`}>
                                            <div className="flex-1 px-0 mt-1 d-flex justify-content-center centrar-check">
                                            <input
                                                type="checkbox"
                                                component={renderFieldCheck}
                                                checked={row.crear}
                                                disabled={this.isCheckDisabled(row)}
                                                onChange={(e) => {row.crear = e.target.checked, this.forceUpdate()}}
                                            />
                                            </div>
                                        </label>
                                    },
                                })
                            }
                            }
                        >
                            CREAR
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width="7%"
                            dataFormat={(cell, row) => {
                                return customStandardActions(cell, {
                                    adicional: (c, r) => {
                                        return <label className={`mb-0 d-flex py-1 px-0 px-sm-1 flex-row algin-items-center`}>
                                            <div className="flex-1 px-0 mt-1 d-flex justify-content-center centrar-check">
                                            <input
                                                type="checkbox"
                                                component={renderFieldCheck}
                                                checked={row.ver}
                                                disabled={this.isCheckDisabled(row)}
                                                onChange={(e) => {row.ver = e.target.checked, this.forceUpdate()}}
                                            />
                                            </div>
                                        </label>
                                    },
                                })
                            }
                            }
                        >
                            VER
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width="7%"
                            dataFormat={(cell, row) => {
                                return customStandardActions(cell, {
                                    adicional: (c, r) => {
                                        return <label className={`mb-0 d-flex py-1 px-0 px-sm-1 flex-row algin-items-center`}>
                                            <div className="flex-1 px-0 mt-1 d-flex justify-content-center centrar-check">
                                            <input
                                                type="checkbox"
                                                component={renderFieldCheck}
                                                checked={row.editar}
                                                disabled={this.isCheckDisabled(row) || true}
                                                onChange={(e) => {row.editar = e.target.checked, this.forceUpdate()}}
                                            />
                                            </div>
                                        </label>
                                    },
                                })
                            }
                            }
                        >
                            EDITAR
                        </TableHeaderColumn>
                        {/* <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width="7%"
                            dataFormat={(cell, row) => {
                                return customStandardActions(cell, {
                                    adicional: (c, r) => {
                                        return <label className={`mb-0 d-flex py-1 px-0 px-sm-1 flex-row algin-items-center`}>
                                            <div className="flex-1 px-0 mt-1 d-flex justify-content-center centrar-check">
                                            <input
                                                type="checkbox"
                                                component={renderFieldCheck}
                                                checked={row.eliminar}
                                                disabled={this.isCheckDisabled(row) || true}
                                                onChange={(e) => {row.eliminar = e.target.checked, this.forceUpdate()}}
                                            />
                                            </div>
                                        </label>
                                    },
                                })
                            }
                            }
                        >
                            ELIMINAR
                        </TableHeaderColumn> */}
                    </Grid>

                    <div className="row  justify-content-sm-around justify-content-center">
                        <Link className="btn btn-secondary  align-self-center" to="/usuarios" >CANCELAR</Link>
                        <button type="button" onClick={()=>{guardar(this.props.match.params.id)}} className="btn btn-primary m-1 align-self-center">GUARDAR</button>
                    </div>
            </CardSimple>
        );
    }
}
